import React, { useState } from 'react';
import PartidosHistorial from './PartidosHistorial.js';
import SelectorRival from './SelectorRival.js';
import TotalesHistorial from './TotalesHistorial.js';
import TotalesRivales from './TotalesRivales.js';
import * as Funciones from '../funciones/FuncionesHistoriales.js';
import { ListaPartidos } from '../constantes/Filtros.js';
import styles from './BaseHistoriales.module.css';

const BaseHistoriales = (props) => {
  const tipoHistorial = props.tipo;
  const competidor = props.competidor;
  const [rival, setRival] = useState(Funciones.RivalVacio());
  const [filtro, setFiltro] = useState(ListaPartidos.TOTALES);

  const onBuscar = (rival) => {
    setRival(rival);
  };

  const onFiltroElegido = (filtro) => {
    setFiltro(Number(filtro));
  };

  const onRivalTotalesElegido = (rivalElegido) => {
    if (!rival || !rivalElegido) return;
    setRival({
      ...rival,
      objeto: rivalElegido,
    });
  };

  const onVolverATotales = () => {
    setRival({
      ...rival,
      objeto: null,
    });
  };

  return (
    <div className={`${styles.columnas}`}>
      <div className={`${styles.columnaSelector}`}>
        <SelectorRival tipoHistorial={tipoHistorial} competidor={competidor} onBuscar={onBuscar} />
        {rival?.objeto && (
          <div className={`${styles.columnaHistorial}`}>
            <TotalesHistorial
              tipoHistorial={tipoHistorial}
              competidor={competidor}
              rival={rival}
              filtro={filtro}
            />
          </div>
        )}
      </div>

      {rival?.objeto ? (
        <React.Fragment>
          <div className={`${styles.columnaPartidos}`}>
            <PartidosHistorial
              tipoHistorial={tipoHistorial}
              competidor={competidor}
              rival={rival}
              filtro={filtro}
              onFiltroElegido={onFiltroElegido}
            />
            {rival?.totales && (
              <button className={`${styles.botonVolver}`} onClick={onVolverATotales}>
                Volver a la lista
              </button>
            )}
          </div>
        </React.Fragment>
      ) : (
        <div className={`${styles.columnaResultados}`}>
          <TotalesRivales
            tipoHistorial={tipoHistorial}
            competidor={competidor}
            rival={rival}
            onRivalElegido={onRivalTotalesElegido}
          />
        </div>
      )}
    </div>
  );
};

export default BaseHistoriales;
